import { h, Host } from "@stencil/core";
import { AppState } from "../../service/app-state";
export class StickyHeader {
    constructor() {
        this.show = true;
        this.isScrollable = true;
        this.lastScrollTop = 0;
        this.delta = 25;
    }
    componentDidLoad() {
        this.navbarHeight = this.el.clientHeight;
    }
    onMouseenter() {
        this.isScrollable = false;
    }
    onMouseleave() {
        this.isScrollable = true;
    }
    scrollListener() {
        if (!this.isScrollable) {
            return;
        }
        if (AppState.languageSelect) {
            return;
        }
        this.setHeaderVisibility();
    }
    setHeaderVisibility() {
        const scrollTop = window.scrollY;
        if (Math.abs(this.lastScrollTop - scrollTop) <= this.delta) {
            return;
        }
        this.show = !(scrollTop > this.lastScrollTop && scrollTop > this.navbarHeight);
        this.lastScrollTop = scrollTop;
    }
    render() {
        return (h(Host, { key: 'a6d042c399bff85bac954f6733e13761c2b49c88', class: { 'show': this.show } }, h("slot", { key: '08c39bfb9c6e3d003a05239cc8383a1f88941cb7' })));
    }
    static get is() { return "uvex-sticky-header"; }
    static get states() {
        return {
            "show": {}
        };
    }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "mouseenter",
                "method": "onMouseenter",
                "target": undefined,
                "capture": false,
                "passive": true
            }, {
                "name": "mouseleave",
                "method": "onMouseleave",
                "target": undefined,
                "capture": false,
                "passive": true
            }, {
                "name": "scroll",
                "method": "scrollListener",
                "target": "document",
                "capture": false,
                "passive": true
            }];
    }
}
//# sourceMappingURL=sticky-header.js.map
